import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';

import 'mapbox-gl/dist/mapbox-gl.css';

import mapboxgl from 'mapbox-gl'; 
mapboxgl.accessToken = 'pk.eyJ1Ijoid2FuZnJhbmNrIiwiYSI6ImNsNTJiejZ1aTBlNHUzbXFpeDM0dGxrbWYifQ.3rkGBn5LTsZt-kwYoXeBTw';

const container = document.getElementById('adasis-map-demo-root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
      <App />
    </Provider>
);
